import Cookies from 'js-cookie'
import { useSelector } from 'react-redux'
import {
  createBrowserRouter,
  Outlet,
  RouterProvider,
  Navigate,
} from 'react-router-dom'

import {
  Home,
  Login,
  ResetPassword,
  CaseworkDetail,
  Directory,
  ConstituentDetail,
  StaffProfile,
  Casework,
  AdminPortal,
  Tools,
  CreateCasework,
} from './components/pages'
import EditCasework from './components/pages/EditCasework'
import { AddressLookupTool } from './components/tools'
import { Compendium } from './components/tools/compendium'
import { Reports } from './components/tools/reports'
import { Loading, SiteDisclaimer } from './components/ui'
import ErrorBoundary from './ErrorBoundary'
import IdleTimeout from './IdleTimeout'
import Layout from './Layout'
import { authLoader } from './loaders'
import { useGetProfileQuery } from './redux/rtkq/profileApi'
import './print.css'

const ProtectedRoute = ({ children }) => {
  const user = useSelector(state => state.auth.user)

  const token = Cookies.get('api_token')

  useGetProfileQuery(undefined, {
    skip: !token,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  })

  if (!token) {
    return <Login />
  }

  if (!user) return <Loading />

  return (
    <Layout>
      <SiteDisclaimer />
      <IdleTimeout token={token} />
      {children}
    </Layout>
  )
}

const App = () => {
  const router = createBrowserRouter([
    {
      path: '/reset_password/:token',
      element: <ResetPassword />,
    },
    {
      element: (
        <ProtectedRoute>
          <Outlet />
        </ProtectedRoute>
      ),
      loader: authLoader,
      errorElement: <ErrorBoundary />, // catches errors for everything inside
      children: [
        {
          path: '/',
          element: <Home />,
        },
        { path: '/directory', element: <Directory /> },
        { path: '/casework', element: <Casework /> },
        { path: '/casework/create', element: <CreateCasework /> },
        { path: '/directory/constituents/:id', element: <ConstituentDetail /> },
        { path: '/tools', element: <Tools /> },
        { path: '/tools/address-lookup', element: <AddressLookupTool /> },
        { path: '/tools/reports', element: <Reports /> },
        { path: '/tools/compendium', element: <Compendium /> },
        { path: '/casework/:case_num', element: <CaseworkDetail /> },
        { path: '/casework/:case_num/edit', element: <EditCasework /> },
        { path: '/casework/archive/:case_num', element: <CaseworkDetail /> },
        { path: '/directory/staff/:id', element: <StaffProfile /> },
        { path: '/admin', element: <AdminPortal /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/' replace />,
    },
  ])

  return <RouterProvider router={router} />
}

export default App
